<template>
    <div class="user-box">
        <div class="user-box__avatar-container">
            <img
                v-lazy-load
                class="user-box__avatar-image"
                :alt="review.member.name"
                src="/nuxt-assets/images/lazy-load-error.svg"
                :data-src="review.member.avatar"
            />
        </div>
        <span class="user-box__avatar-icon">
            <img v-lazy-load src="/nuxt-assets/images/lazy-load-error.svg" :data-src="`/nuxt-assets/icons/review.svg`" alt="review" />
        </span>
        <div class="user-box__number-box">
            <span class="user-box__number-box__number">{{ review.member.stats.userReviewsCount }}</span>
            <span class="user-box__number-box__text">
                {{ $t('reviewClub.review', review.member.stats.userReviewsCount) }}

                <ObjectsTextTooltip v-if="$t('reviewClub.clubText')" :text="$t('reviewClub.clubText')">
                    <span class="help">
                        <img v-lazy-load src="/nuxt-assets/images/lazy-load-error.svg" :data-src="`/nuxt-assets/icons/i.svg`" alt="i" />
                    </span>
                </ObjectsTextTooltip>
                <!-- FIXME Tooltip v-b-tooltip.hover="{ title: $t('reviewClub.clubText'), html: true, variant: 'white', placement: 'top' }" -->
            </span>
        </div>
        <div class="user-box__number-box">
            <span class="user-box__number-box__number"> {{ review.member.stats.commentsCount }} </span>
            <span class="user-box__number-box__text"> {{ $t('reviewClub.reviews') }} </span>
        </div>
        <div class="user-box__number-box">
            <span class="user-box__number-box__number"> {{ review.member.stats.ordersCount }} </span>
            <span class="user-box__number-box__text"> {{ $t('reviewClub.orders') }} </span>
        </div>
        <div class="user-box__number-box">
            <span class="user-box__number-box__number"> {{ review.member.stats.points }} </span>
            <span class="user-box__number-box__text">{{ $t('reviewClub.points', review.member.stats.points) }}</span>
        </div>
    </div>
</template>

<script lang="ts">
import { PropType } from 'vue'
import Review from '~/models/ReviewClub/Review'

export default {
    props: {
        review: {
            type: Object as PropType<Review>,
            default: () => ({} as Review),
        },
    },
}
</script>

<style lang="scss" scoped>
.user-box {
    width: 92px;
    border-radius: 10px 0 0 10px;
    position: relative;

    &__avatar-container {
        margin: 10px 12px;
        width: 66px;
        height: 66px;
        position: relative;
        overflow: hidden;
        border-radius: 50%;
        border: 3px solid transparent;
        display: flex;
        align-items: center;
        justify-content: center;

        &--pilulka {
            border: 3px solid $color-cta;
        }
    }

    &__avatar-icon {
        position: absolute;
        top: 50px;
        right: 7px;
    }

    &__number-box {
        text-align: center;
        margin-bottom: 11px;

        &__number {
            font-size: 16px;
            display: block;
            font-weight: 500;
        }

        &__text {
            font-size: 12px;
            display: block;

            .help {
                cursor: help;
                position: relative;
                top: -1px;
            }
        }
    }
}
</style>
